import { mobileReg } from "@/utils/regs";


export const initFormData = {
  id: 0,
  customerName: '',
  customerPhone: '',
  province: '',
  city: '',
  area: '',
  detailsAddress: '',
  defaultAddress: 1,
  type: 0
}

export const rules = (editFormData: any) => {
  return {
    address: [
      {
        validator: (rule: any, value: boolean, callback: any) => {
          if (!editFormData.value.area) {
            callback(new Error("请选择省市区"));
          } else {
            callback();
          }
        },
      },
    ],
    detailsAddress: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
    customerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    customerPhone: [
      { required: true, message: "请输入联系方式", trigger: "blur" },
      { pattern: mobileReg, message: "联系方式不符合格式", rigger: "blur" },
    ],
  }
};

